import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import './AccessDenied.css';

class AccessDenied extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  static defaultProps = {

  }

  componentDidMount() {
    const { dispatch } = this.props
    document.title = "Access Denied - Admin - Better Spaces"
  }

  render() {
    return (
      <div className="accessDeniedInfo">You don't have access to this section</div>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state
  }
}

export default connect(mapStateToProps)(AccessDenied);



// WEBPACK FOOTER //
// ./src/containers/AccessDenied.js